(function () {
    ko.utils.writeProperty = function(allBindingsAccessor, bindingName, val) {
        var writer = allBindingsAccessor()._ko_property_writers[bindingName];
        writer(val);

    };
    ko.updateViewModel = function (viewModel, data) {
        var vm = viewModel;
        if (ko.isObservable(viewModel)) {
            vm = viewModel();
        }
        $.each(data, function (key, value) {
            if ($.isFunction(vm[key]))
                vm[key](value);
        });
        if (ko.isObservable(viewModel)) {
            viewModel(vm);
        }
    };
    ko.mapViewModel = function (viewModel, data) {
        var vm = viewModel;
        if (ko.isObservable(viewModel)) {
            vm = viewModel();
        }
        $.each(data, function (key, value) {
                vm[key] = value;
        });
        if (ko.isObservable(viewModel)) {
            viewModel(vm);
        }
    };
   
    ko.viewModelFactory = function (viewModelType) {
        return function (vm) {
            // Set the prototype so the data is available when constructed
            
            viewModelType.prototype = vm;
            var newModel = new viewModelType(vm);
            // Clear prototype to prevent data leaking
            viewModelType.prototype = {};
            $.extend(newModel, vm);

            return newModel;
        };
    };
    ko.createViewModel = function (viewModelType, data) {
        
        var factory = ko.viewModelFactory(viewModelType);
        return factory(data);
    };
    
    ko.ensurePropertiesAreObservable = function (obj, exclude, recurse) {
        
        if (recurse === undefined && exclude !== undefined && !jQuery.isArray(exclude)) {
            exclude = [];
            recurse = true;
        }
        if (!jQuery.isArray(obj)) {

            $.each(obj, function (key, value) {
                if (exclude.indexOf(key) == -1) 
                    obj[key] = ko.isObservable(value) ? value : ko.observable(value);
                if (recurse === true)
                ko.ensurePropertiesAreObservable(obj[key](),recurse);
            });
        }
    };
    ko.subscribable.fn.isEmpty = function() {
        return this() == null || this() == "" || this() == false;
    };
    ko.extenders.dirty = function (target, startDirty) {
       
        var cleanValue = ko.observable(ko.utils.unwrapObservable(target));
        var dirtyOverride = ko.observable(ko.utils.unwrapObservable(startDirty));

        target.isDirty = ko.computed(function () {
            

            return dirtyOverride() || ko.viewmodel.toModel(target) != cleanValue();
        });

        target.markClean = function () {
            cleanValue(ko.viewmodel.toModel(target));
            dirtyOverride(false);
        };
        target.markDirty = function () {
            dirtyOverride(true);
        };

        return target;
    };
    
    ko.extenders.validate = function (target, rules) {

        target.rules = ko.observable(rules);

        return target;
    };
    
    ko.extenders.numeric = function(target, precision) {
        //create a writeable computed observable to intercept writes to our observable
        var result = ko.computed({
            read: target,  //always return the original observables value
            write: function(newValue) {
                var current = target(),
                    roundingMultiplier = Math.pow(10, precision),
                    newValueAsNum = isNaN(newValue) ? 0 : parseFloat(+newValue),
                    valueToWrite = Math.round(newValueAsNum * roundingMultiplier) / roundingMultiplier;

                //only write if it changed
                if (valueToWrite !== current) {
                    target(valueToWrite);
                } else {
                    //if the rounded value is the same, but a different value was written, force a notification for the current field
                    if (newValue !== current) {
                        target.notifySubscribers(valueToWrite);
                    }
                }
            }
        });

        //initialize with current value to make sure it is rounded appropriately
        result(target());

        //return the new computed observable
        return result;
    };
    ko.bindingHandlers.validate = {
        init: function (element, valueAccessor, allBindings, context) {
            var options = ko.utils.unwrapObservable(valueAccessor());
            if (options === true)
                options = allBindings().value.rules();
            
            if (context.isValid == undefined) {
                context.isValid = function (container) {
                    //$(context.IsValid.elements).valid();
                    $($(element)[0].form).valid();
                    var validator = $($(element)[0].form).validate();
                    

                    return !validator.errorList.length > 0;
                };
                context.isValid.elements = [];
            }
            var validateElement = function() {

                // Validate single
                window.setTimeout(function() {
                    if (!$(element).valid()) {
                        var validator = $($(element)[0].form).validate();
                        validator.settings.focusInvalid = true;
                        var errorMessages = "<br />";
                        for (var i = 0; i < validator.errorList.length; i++) {

                            errorMessages = errorMessages + validator.errorList[i].message + "<br />";
                        }

                        if (validator.errorList.length > 0) {
                            var text = $.dictionary.getValue("followingErrors") + "<br />" + errorMessages;
                            $.errorDialog(text, $.dictionary.getValue("validationFailed"), function() {
                                $(this).remove();
                            });
                        }
                    }
                }, 0);
            };
            if (allBindings().value != undefined) {
                allBindings().value.subscribe(validateElement);
                if (allBindings().value.rules != undefined)
                    allBindings().value.rules.subscribe(validateElement);
            }
            context.isValid.elements.push(element);
            
            if (element.name == '') {
                $(element).uniqueId();
                $(element).attr('name', $(element).attr('id'));
            }
          $($(element)[0].form).uniqueId();
          $($(element)[0].form).attachValidator();
          ko.computed(function () {
              if (element.form==null)
                  return;

              if (allBindings().value.rules)
                  allBindings().value.rules();

              var options = ko.utils.unwrapObservable(valueAccessor());
              if (options === true)
                  options = allBindings().value.rules();

              for (var i in options) {
                  if (ko.isObservable(options[i])) {
                      options[i].subscribe(function (v) {
                          var singleOpt = {};
                          singleOpt[i] = v;
                          window.setTimeout(function () {
                              if (element.form == null)
                                  return;
                              $(element).rules("add", ko.toJS(singleOpt));
                              validateElement();
                          }, 10);
                      });
                      options[i] = (options[i])();
                  }
              }
              
              $(element).rules("add", ko.toJS(options));
            });
          
      }  
    };
    ko.bindingHandlers.autoSuggest = {
        init: function(element, valueAccessor, allBindingsAccessor) {
            var items = allBindingsAccessor().items || {};
            var values = ko.utils.unwrapObservable(items);
            var selectedValue = ko.utils.unwrapObservable(valueAccessor()) || $(element).val();
            debugger;
            var uniqId = $(element).uniqueId().attr('id');

            $(element).autoSuggest(values, {
                
                asHtmlID: uniqId,
                formatList: function(d, li) {
                    li.html(d.Key);
                    return li;
                },
                selectedValuesProp: "Value",
                selectedItemProp: "Key",
                searchObjProps: "Key,Value",
                selectionAdded: function(elem) {
                    elem.find('a').remove();
                    $('#as-selections-' + uniqId).removeClass('error');
                }
            });
        }
    };
    ko.bindingHandlers.readOnly = {
        update: function (element, valueAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor());
            if (value) {
                element.setAttribute("readonly", true);
            } else {
                element.removeAttribute("readonly");
            }
        }
    };
    ko.bindingHandlers.combo = {
        init: function (element, valueAccessor, allBindingsAccessor) {

            
            var items = allBindingsAccessor().items || {};
            var values = ko.utils.unwrapObservable(items);
            var selectedValue = ko.utils.unwrapObservable(valueAccessor()) || $(element).val();
            

            // This will be called when the binding is first applied to an element
            // Set up any initial state, event handlers, etc. here
            var uniqId = $(element).uniqueId().attr('id');

            var list_id = uniqId + "_list";
            var list = $("#" + list_id);
            if ($("#" + list_id).length == 0) {
                list = $("<ul></ul>").appendTo($(document.body));
                list.attr('id', list_id).addClass('mcdropdown_menu').addClass('nowrap');
            } else {
                list.find('li').remove();
            }
            
            var getValues = function (values) {
                var valueArray = [];
                if (values !== undefined && values != null) {
                    if (!jQuery.isArray(values)) {
                        $.each(values, function(key, val) { valueArray.push([key, val]); });
                    } else {
                        $.each(values, function(index, val) {
                            if (val.Level != undefined) {
                                valueArray.push([val.ID, val.Name, getValues(val.Children)]);
                            } else {
                                if (jQuery.isArray(val)) {
                                    valueArray.push(val);
                                } else {
                                    valueArray.push([index, val]);
                                }
                            }
                        });
                    }
                }
                return valueArray;
            };
            var valueArray = getValues(values);
            
            var convertArrToElements = function(valueArray, parentEl) {
                for (var i in valueArray) {
                    var valueItem = ko.utils.unwrapObservable(valueArray[i]);
                    var listEl = $("<li></li>").attr('rel', ko.utils.unwrapObservable(valueItem[0])).text(ko.utils.unwrapObservable(valueItem[1]));
                    if (valueItem.length > 2 && $.isArray(valueItem[2]) && valueItem[2].length > 0) {
                        var childGroupEl = $('<ul></ul>');
                        convertArrToElements(valueItem[2], childGroupEl);
                        childGroupEl.appendTo(listEl);
                    }
                    listEl.appendTo(parentEl);
                }
            };
            convertArrToElements(valueArray, list);
            if (ko.isObservable(items))
                items.subscribe(function (nv) {
                    var values = nv;
                    
                    // Items have changed:
                    var list = $('#' + list_id);
                    list.find('li').remove();
                    var valueArray = getValues(values);
                    convertArrToElements(valueArray, list);
                  
                });
            
            $(element).mcDropdown('#' + list_id, {
                select: function (val) {
                    valueAccessor(val);
                    var observable = valueAccessor();
                    if (ko.isObservable(observable))
                        observable(val);
                    else
                        ko.utils.writeProperty(allBindingsAccessor, "combo", val);
                },
                init: function (menu, hdn) {
                    this.setValue(selectedValue);
                    
                }
            });
            

        },
        update: function (element, valueAccessor, allBindings) {
            var selectedValue = ko.utils.unwrapObservable(valueAccessor());
           
            
            var dd = $(element).parent().find("input[type=hidden]").mcDropdown();

            
            if (selectedValue != dd.getValue())
                dd.setValue(selectedValue);


        }
    };
    
   

})();